import request from '../request'
import axios from 'axios'

/**
 * 获取优惠券
 */
export function getCoupon(data) {
  return request({
    url: '/app/pk/coupon/insertRecord',
    method: 'POST',
    data
  })
}

/**
 * 获取停车信息
 */
export function getParkingInfo(params) {
  return request({
    url: '/app/pk/getWaitPayOrder',
    method: 'get',
    params
  })
}

/**
 * 立即缴费
 */
export function parkingPay(data) {
  return request({
    url: '/app/pk/pkPreOrder',
    method: 'post',
    data
  })
}

/**
 * 获取订单支付状态
 */
export function getOrderStatus(params) {
  return request({
    url: '/app/pk/pkQueryTradeOrder',
    method: 'get',
    params
  })
}

/**
 * 无车牌入场
 */
export function noPlateIn({ plateNo, parkId, laneCode }) {
  return request({
    url: `app/pk/noPlateNo/goIn?plateNo=${plateNo}&parkId=${parkId}&laneCode=${laneCode}`,
    method: 'post'
  })
}

/**
 * 无车牌出场
 */
export function noPlateOut({ plateNo, parkId, laneCode }) {
  return request({
    url: `app/pk/noPlateNo/goOut?plateNo=${plateNo}&parkId=${parkId}&laneCode=${laneCode}`,
    method: 'post'
  })
}

/**
 * 获取跳转到小程序的schema码
 */
export function getSchemaCode(params) {
  return axios({
    url: process.env.VUE_APP_BASE_URL + 'app/pk/getSchemeCode',
    method: 'get',
    params
  })
}
